import { api } from '@/api/ApiGateway'

class MaintenanceApi
{
	getMaintenanceStatus(onSuccess, onError)
	{
		api.get('maintenance-status').then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error loading maintenance status.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	createMaintenanceEvent(event, onSuccess, onError)
	{
		api.post('maintenance-event', { 'maintenance_event': event }).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error creating maintenance event.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	updateMaintenanceEvent(event, onSuccess, onError)
	{
		api.patch('maintenance-event', { 'maintenance_event': event }).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error updating maintenance event.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	deleteMaintenanceEvent(eventId, onSuccess, onError)
	{
		api.delete(`maintenance-event/${eventId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error deleting maintenance event.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	startMaintenanceEvent(eventId, onSuccess, onError)
	{
		api.post(`maintenance-event/${eventId}/start`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error starting maintenance event.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	endMaintenanceEvent(eventId, onSuccess, onError)
	{
		api.post(`maintenance-event/${eventId}/end`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error ending maintenance event.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	resetJwtVersionCode(onSuccess, onError)
	{
		api.get(`maintenance-event/reset-jwt-version-code`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error resetting JWT version code.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}
}

export const maintenanceApi = new MaintenanceApi()